import { render, staticRenderFns } from "./passport.component.vue?vue&type=template&id=350df838&scoped=true&"
import script from "./passport.component.vue?vue&type=script&lang=ts&"
export * from "./passport.component.vue?vue&type=script&lang=ts&"
import style0 from "./passport.component.vue?vue&type=style&index=0&id=350df838&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350df838",
  null
  
)

export default component.exports